export default "__VITE_ASSET__fcbETSmM__"